import { getKey, setKey, removeKey, repeat, getIp, initGId, copyToClipbord, judgeClientSystem, isWxBroswer, isWxMiniprogram, isBaiduMiniprogram, isTMDMiniprogram, isIOS, isAndroid, isApiH5 } from './utils'
import { generateUUID } from '../services/stat'
import { Base64 } from 'js-base64'
import axios from './axios'
import { dateUtils } from './date-utils'
import coordtransform from 'coordtransform'
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'
import qs from 'qs'
import { mapActions } from 'vuex'
import wx from 'weixin-webview-jssdk'


/**
 * 金钱格式化
 * 每三位一个逗号 保留2位小数
 * @param num
 * @returns {string}
 */
function formatMoney (num) {
  try {
    return num.toFixed(2).replace(/\B(?=(\d{3})+\D)/g, ',')
  } catch (err) {
    return '0.00'
  }
}

/**
 * 数字格式化
 * 每三位一个逗号 不保留小数位
 * @param num
 * @returns {string}
 */
function formatAmount (num) {
  try {
    return num.toFixed(0).replace(/\B(?=(\d{3})+(\D|$))/g, ',')
  } catch (err) {
    return '0.00'
  }
}

/**
 * 脱敏
 * @param str
 * @param starOffset
 * @param endOffset
 * @returns {string}
 */
function stringMosaic (str, starOffset, endOffset) {
  if (!str) return ''
  str = String(str)
  const mosaic = repeat('*', str.length - starOffset - endOffset)
  const exp = new RegExp(`^(.{${starOffset}}).*(.{${endOffset}})$`)
  return str.replace(exp, (origin, $1, $2) => {
    return `${$1}${mosaic}${$2}`
  })
}

/**
 * 日期格式化
 * @param fmt 默认 年/月/日
 * @param dateString
 * @returns {string}
 */
const formatDate = (dateString, fmt = 'YYYY/MM/DD') => {
  return dateUtils.format(dateString, fmt)
}
// 日期的后一天
const formatDateNextDay = (dateString, fmt = 'YYYY/MM/DD') => {
  return dateUtils.nextDates(dateString, 0, fmt)
}

const isEmptyString = (str) => {
  return !str
}

/**
 * 获取地理信息
 * 返回一个数组 [纬度，经度]
 * @returns {Promise<any>}
 */
const getGeolocation = (sensors) => {
  return new Promise(resolve => {
    sensors && sensors.track('getGeolocationFromInPormise')
    setTimeout(() => {
      sensors && sensors.track('getGeolocationFromSetTimeout')
      resolve(false)
    }, 3000)
    try {
      // eslint-disable-next-line
      navigator.geolocation.getCurrentPosition(res => {
        if (res.coords) {
          const { longitude, latitude } = res.coords
          console.log('原始定位：', longitude, latitude)
          sensors && sensors.track('geolocationInit', {
            positons: { longitude, latitude }
          })
          try {
            const gcjResult = coordtransform.wgs84togcj02(longitude, latitude)
            const result = coordtransform.gcj02tobd09(gcjResult[0], gcjResult[1])
            console.log('百度定位：', result)
            resolve(result)
          } catch (error) {
            sensors && sensors.track('geolocationConvertFail', {
              positons: { longitude, latitude }
            })
            console.log('获取定位失败', error)
            resolve(false)
          }
        } else {
          resolve(false)
        }
      }, err => {
        console.log('获取定位失败', err)
        sensors && sensors.track('getGeolocationFail', { errorMsg: err.message })
        resolve(false)
      }, {
        enableHighAccuracy: true,
        timeout: 3000,
        maximumAge: 0
      })
    } catch (exp) {
      resolve(false)
    }
  })
}

const commonMethods = {
  data () {
    return {
      channel: getKey('channel'),
      downloadVisible: false,
      webclipPopVisible: false,
      iosWxmpQRCodeDialogVisible: false,
      iosWxmpLinkDialogVisible: false,
      copyPopVisible: false,
      jumpPosition: {
      },
      isFirstAndApp: null,
      wxmpType: '',
      packageKey: '',
      appUrl: '',
      uaIsIOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
      isWechat: navigator.userAgent.toLocaleLowerCase().includes('micromessenger')
    }
  },
  mounted () {
    const historyStash = getKey('historyStash') || {}
    const pathName = window.location.pathname
    if (window.history.length === 1) {
      historyStash[pathName] = 'Y'
    }
    this.isFirstAndApp = historyStash[pathName] === 'Y'
    setKey('historyStash', historyStash)
  },
  computed: {
    isApiH5 () {
      return isApiH5()
    },
    IsIosDownload () {
      return this.jumpPosition === 'APP_PACKAGE'
    },
    isIosWebClip () {
      return this.jumpPosition === 'WebClip'
    },
    isWxmpQrCode () {
      return this.jumpPosition === 'WXMP' && this.wxmpType === 'WXMP_QR_CODE'
    },
    isWxmpLink () {
      return this.jumpPosition === 'WXMP' && this.wxmpType === 'WXMP_LINK'
    },
    
    // 是否展示弹窗蒙层（只在支付宝、和IOS中的微信浏览器）
    isShowMask () {
      const ua = navigator.userAgent
      const isAli = !!ua.toLowerCase().match(/AliApp/i)
      const isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
      const isIpad = ua.indexOf('iPad') > -1
      if (isAli || ((isiOS || isIpad) && isWxBroswer())) {
        return true
      }
    },
    // 是否安卓手机
    isAndroid () {
      return judgeClientSystem() === 'Android'
    },
    isQlc () {
      const channel = this.$route.query.channel || getKey('channel')
      return channel === 'qlc'
    },
    isIosSafari () {
      const isIosDevice = /iPhone|iPad|iPod/i.test(navigator.userAgent)
      const isInSafari = /Safari/i.test(navigator.userAgent)
      const isAppleWebKit = /AppleWebKit/i.test(navigator.userAgent)
      return isIosDevice && isAppleWebKit && isInSafari
    }    
  },
  methods: {
    async sleep (s = 1000) {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve()
        }, s)
      })
    },
    routerToProtocol (path) {
      const origin = process.env.VUE_APP_PROURL
      switch (path) {
        case '/tmd/protocol/login': // 《用户注册及服务协议》 小程序单独协议 由于这里没有场景
          window.location.href = `${origin}/protocol/android/login?exit=N`
          break
        case '/protocol/privacy': // 《隐私政策》
        case '/protocol/h5/privacy': // 《隐私政策》
        case '/tmd/protocol/privacy': // 《隐私政策》 兼容老写法
          if (hasNativeMethod('exit') && judgeClientSystem() !== 'IOS') {
            window.location.href = `${origin}/protocol/android/privacy?exit=N`
          } else if (isTMDMiniprogram()) {
            window.location.href = `${origin}/protocol/tmd/mp-privacy`
          } else {
            window.location.href = `${origin}/protocol/h5/privacy`
          }
          break
      }
    },
   
    /**
     * 返回首页
     * @param {boolean} [needsBackToNativeHome=false] 是否需要返回到原生首页 (只在APP中有效）
     */
    async backHome (needsBackToNativeHome = false, needBackToMiniProgramHome = true) {
      if (isTMDMiniprogram()) {
        // 微信小程序
        if (needBackToMiniProgramHome) {
          wx.miniProgram.postMessage({ data: { eventType: 'BACK_HOME', eventId: '', url: '', value: null } })
        }
        wx.miniProgram.navigateBack()
      } else if (['API-XHQB', 'API-WEIBO'].includes(getKey('channel'))) {
        window.location.href = getKey('successUrl')
      } else if (hasNativeMethod('navigateTo') && (judgeClientSystem() !== 'IOS' || (judgeClientSystem() === 'IOS' && getKey('appChannel') === 'official-iOS'))) {
        if (needsBackToNativeHome) {
          jsBridge('navigateTo', { path: 'home', exitCurrent: true })
        } else {
          jsBridge('exit')
        }
      } else {
        this.$router.push('/')
      }
    },
    // 对于嵌入到第三方 有时候获取不到query
    getParams () {
      if (!window.location.search) {
        return {}
      } else {
        const _search = window.location.search.replace('?', '')
        const params = qs.parse(_search) || {}
        const _query = this.$route.query
        if (_query && Object.keys(_query).length) {
          return _query
        }
        return params
      }
    },
    back (exit) {
      if (hasNativeMethod('exit') && (this.isFirstAndApp || exit)) {
        jsBridge('exit')
      } else {
        this.$router.go(-1)
      }
    },
    /**
     * 针对第三方API导流 收集数据
     */
    async sendDataForThird () {
      let appData = {}
      console.log(hasNativeMethod('getApiDeviceInfo'))
      if (hasNativeMethod('getApiDeviceInfo')) {
        const { data } = await jsBridge('getApiDeviceInfo')
        console.log(data)
        appData = data
      }

      // 获取GID
      const deviceId = getKey('uuid')

      // 获取是安卓还是ios
      const appVersionType = judgeClientSystem() === 'IOS' ? 'iphone' : 'android'

      // 系统时区
      const date = new Date()
      const systemTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone

      // 系统时间
      const systemTime = formatDate(date, 'hh:mm:ss')

      // 系统日期
      const systemDate = formatDate(date, 'YYYY-MM-DD')

      // 过滤安卓传过来的空对象
      const newData = {}
      Object.keys(appData || {}).map(key => {
        if (appData[key]) {
          newData[key] = appData[key]
        }
      })
      const params = Object.assign({}, { deviceId, appVersionType, systemTimezone, systemDate, systemTime }, { ...newData })
      return axios.post('/diversion/v1/device-info', params)
    },
    // 间隔日判断
    isIntervalDay (type, days) {
      const lastShowTime = getKey(type)
      let lastShowDate
      if (lastShowTime) {
        lastShowDate = new Date(lastShowTime)
        lastShowDate.setHours(0, 0, 0, 0)
        lastShowDate.setDate(lastShowDate.getDate() + days)
      } else {
        return true
      }
      return new Date() > lastShowDate
    },
    // 获取下个星期一的时间戳
    getNextMondayTimestamp () {
      const now = new Date()
      const dayOfWeek = now.getDay()
      const daysUntilNextMonday = (dayOfWeek === 0 ? 1 : 8 - dayOfWeek)
      const nextMonday = new Date()
      nextMonday.setDate(now.getDate() + daysUntilNextMonday)
      nextMonday.setHours(0, 0, 0, 0)
      return nextMonday.getTime()
    },
    isIntervalNextMon (type) {
      const lastShowTime = getKey(type)
      let showDialog = false
      
      if (lastShowTime !== this.getNextMondayTimestamp()) {
        showDialog = true
        setKey(type, this.getNextMondayTimestamp())
      }
      return showDialog
    },
    isIntervalDayBySession (type, days) {
      const lastShowTime = sessionStorage.getItem(type)
      let lastShowDate
      if (lastShowTime) {
        lastShowDate = new Date(lastShowTime)
        lastShowDate.setHours(0, 0, 0, 0)
        lastShowDate.setDate(lastShowDate.getDate() + days)
      } else {
        return true
      }
      return new Date() > lastShowDate
    },
    callAppBySchema (schema) {
      return new Promise((resolve, reject) => {
        let node = document.createElement('a')
        const body = document.body
        node.style.display = 'none'

        let clear = function (evt, isTimeout) {
          node.onload = null
          body.removeChild(node)
          node = null
        }

        node.onload = clear
        node.href = schema
        body.appendChild(node)
        node.click()
        let now = Date.now()

        setTimeout(() => {
          let newTime = Date.now()

          if (newTime - now > 1100) {
            resolve(true)
          } else {
            resolve(false)
          }
          clear()
        }, 1000)
      })
    },
    //  获取安卓下载链接
    async  getAndradoidUrl () {
      const userInfo = getKey('userInfo')
      const userId = userInfo ? userInfo.userId : ''
      return new Promise(async (resolve, reject) => {
        const { data } = await axios.get('/redirect/app/download-url', {
          userId,
          uuid: generateUUID()
        })
        if (data && data.success) {
          resolve(data.data)
        } else {
          resolve('https://download.ndmicro.com/apk/release/tmd_Official_release.apk')
        }
      })
    },
    async downloadApp () {
      const userInfo = getKey('userInfo')
      if (isWxMiniprogram() || isBaiduMiniprogram()) {
        // 是微信小程序 || 百度小程序
        if (window.location.search) {
          copyToClipbord(`${window.location.href}&token=${userInfo.token}`)
        } else {
          copyToClipbord(`${window.location.href}?token=${userInfo.token}`)
        }
        this.$message('复制成功', 2000)
      } else {
        if (!this.jumpPosition?.type) {
          await this.getAppInfo()
        }
        // 首页
        if (this.jumpPosition.type === 'H5') {
          return this.$router.replace('/')
        }
        // 关注公众号
        if (this.jumpPosition.type === 'OA') {
          this.downloadVisible = true
          this.$sensors.track('PopupDisplay', { msg_name: '公众号引导弹窗', caseid: 'we_public' })
          return 
        }
        // ios 的 WebClip
        if (this.jumpPosition.type === 'WebClip') {
          if (this.isIosSafari) {
            this.webclipPopVisible = true
          } else {
            this.copyPopVisible = true
          }
          return
        }
        // 小程序
        if (this.jumpPosition.type === 'WXMP') {
          if (this.jumpPosition.code === 'WXMP_QR_CODE') {
            this.iosWxmpQRCodeDialogVisible = true
          } else {
            this.iosWxmpLinkDialogVisible = true
          }
          return 
        }

        if (isIOS() && ['APP_PACKAGE', 'APP'].includes(this.jumpPosition.type)) {
          const appUrl = ['H5-ppd', 'H5-ppd1', 'H5-ppd2'].includes(this.$route.query.channel) ? 'https://itunes.apple.com/cn/app/id' : 'itms-appss://apps.apple.com/cn/app/id'
          this.appUrl = appUrl + this.jumpPosition.code
          window.location.href = this.appUrl
          return 
        }

        if (this.jumpPosition.type === 'APP' && isAndroid()) {
          {
            let androidUrl = await this.getAndradoidUrl() // 安卓下载链接
            const userAgent = navigator.userAgent
            const isTieba = !!userAgent.toLowerCase().match(/tieba/i)
            const isWeiXin = !!userAgent.toLowerCase().match(/MicroMessenger/i)
            const isWeiBo = !!userAgent.toLowerCase().match(/WeiBo/i)
            const isQQ = !!userAgent.match(/\sQQ/)
            if (isWeiXin || isWeiBo || isQQ || isTieba) {
              // 第三方应用打开 腾讯应用宝
              androidUrl = 'https://sj.qq.com/myapp/detail.htm?apkName=com.nd.tmd&info=EB81D9CE029816C8ED6116B67387E055'
              window.location.href = androidUrl
            } else {
              // 浏览器打开
              window.location = androidUrl
            }
          }
        }
      }
    },
    // 获取ios渠道与id
    ...mapActions('user', ['getChannelJumpX', 'getActivityOWN']),
    async getAppInfo (point = false) {
      let res = {}
      if (this.jumpPosition?.type) return 
      if (this.$route?.name === 'landingActiveShareResult') {
        res = await this.getActivityOWN({
          shareCode: this.$route.query.shareCode
        })
      } else {
        res = await this.getChannelJumpX()
      }
      if (res.success) {
        this.jumpPosition = res.data
      }
    },

    async copyUrlAndToast () {
      const androidUrl = await this.getAndradoidUrl() // 安卓下载链接
      if (judgeClientSystem() === 'IOS') {
        if (!this.jumpPosition) {
          await this.getAppInfo()
        }
        copyToClipbord(this.appUrl)
      } else {
        copyToClipbord(androidUrl)
      }
      this.$message('下载链接已复制，请到浏览器中打开', 8000)
    },
    
    getDevice () {
      const deviceInfo = {
        terminal: getKey('terminal') || 'H5',
        appVersion: getKey('appVersion'),
        uuid: generateUUID()
      }
      return Base64.encode(
        JSON.stringify(
          Object.assign({}, deviceInfo, {
            longitude: getKey('longitude') || '',
            latitude: getKey('latitude') || ''
          })
        )
      )
    },
    formatMoney (num) {
      if (!num) return ''
      return formatMoney(num)
    },
    formatAmount (num) {
      if (!num) return ''
      return formatAmount(num)
    },
    // 日期格式化
    formatDate (dateString, fmt) {
      if (!dateString) return ''
      return formatDate(dateString, fmt)
    },
    formatDateNextDay (dateString, fmt) {
      if (!dateString) return ''
      return formatDateNextDay(dateString, fmt)
    },
    isEmptyString (str) {
      return isEmptyString(str)
    },
    isNotEmptyString (str) {
      return !isEmptyString(str)
    },
    // 字符串安全转换，如果为null或者undefined，返回空字符串
    safeString (str) {
      return isEmptyString(str) ? '' : str
    },
    formatMobile (mobile) {
      if (!mobile) return ''
      return stringMosaic(mobile, 3, 4)
    },
    getGeolocation () {
      return getGeolocation(this.$sensors)
    },
    async riskReport (node, userInfo = {}) {
      // 上报设备信息
      let ip, geolocation, gid, channel, _userInfo
      channel = getKey('channel') || 'Official'
      _userInfo = getKey('userInfo') || {}

      try {
        this.$indicator()
        // 针对预览提现节点 NODE===3的时候做埋点
        node === 3 && this.$sensors.track('initGId')
        gid = await initGId()
        node === 3 && this.$sensors.track('getGeolocation')
        geolocation = await this.getGeolocation()
        node === 3 && this.$sensors.track('getIp')
        ip = await getIp()
      } catch (exp) {
        console.log('获取信息错误')
        console.log(`IP:${ip}`)
        console.log(`GPS:${geolocation}`)
        console.log(`GID:${gid}`)
        this.$sensors.track('riskReportGetInfoError', { msg: exp.message })
      } finally {
        this.$indicator.close()
        const eventMapping = {
          1: 'login',
          2: 'lend',
          3: 'cash'
        }
        if (window.hasOwnProperty('BRCore')) BRCore.tools.Tools.sendCollect({ 'event': eventMapping[node] })
        let latitude = ''
        let longitude = ''
        if (getKey('channel') !== 'API-XHQB') {
          latitude = geolocation ? geolocation[1] : ''
          longitude = geolocation ? geolocation[0] : ''
        }
        const _locationInfo = getKey('locationInfo')
        if (getKey('terminal') === 'IOS' && _locationInfo) {
          if (_locationInfo) {
            latitude = _locationInfo.latitude
            longitude = _locationInfo.longitude
          }
        }

        let platform = ''
        const ua = window.navigator.userAgent
        if (ua.includes('NDMicroApp')) {
          platform = 'TMQB_H5'
        } else if (ua.includes('iOS-LxhApp')) {
          platform = 'iOS-H5-LXH'
        } else {
          platform = 'H5'
        }
        const params = {
          traffic: channel,
          node,
          phoneNumber: userInfo.mobile || _userInfo.mobile || '',
          userIdNumber: userInfo.idCard || _userInfo.idCard || '',
          platform: platform,
          product: 'TMD',
          gid: (typeof gid === 'string') ? gid : null,
          data: {
            latitude,
            longitude,
            ip,
            channel
          }
        }
        this.$sensors.track('riskReport', { params: JSON.stringify(params) })
        try {
          await axios.post('/pushdata/device-info', params, { notNeedBaseURL: true })
        } catch (error) {
          this.$sensors.track('riskReportError', { msg: error.message })
        }
      }
    },
    // 跳转至尊王卡相关页面
    jumpToKingCardPage () {
      const origin = process.env.VUE_APP_PAYURL
      const gid = localStorage.getItem('gid')
      const token = getKey('userInfo', 'token') || ''
      const channel = getKey('channel') || ''
      const data = `gid=${gid}&token=${token}&channel=${channel}`
      window.location.href = `${origin}/vip/skc?${data}&refurl=${window.location.origin}`
      return false
    },
    // 在安卓里面直接关闭，其他不做任何处理
    handleExit () {
      if (hasNativeMethod('exit') && judgeClientSystem() !== 'IOS') {
        jsBridge('exit')
      }
    },
    // 跳转客服页面
    handleJumpService () {
      this.$router.push('/service')
    },
    handleLandingJump (type, them) {
      if (type === 'H5') {
        return this.$router.push('/')
      } else {
        return this.$router.push(`/landing/${them}/result?channel=${this.channel}`)
      }
    },
    /*
    * 判断对应会员类型的状态
    @param memberType: MemberGoodsGroupCd.OLD/ENJOY/LIGHT_ENJOY/SVIP/PRIVILEGE/UNLIMITED/GVIP/GPVIP/XMVIP_API
    @param memberGoodsGroupCd: 当前会员类型，通常由接口返回
    @param memberStatus: 会员状态，通常由接口返回

    @return memberType对应的状态，isValid-有效；isFROZEN-冻结，ISEXPIRED-过期
    !hahah
    ?hahaha
    @heihei
    */
    getMemberStatus (memberType, memberGoodsGroupCd, memberStatus) {
      const isMemberTheSame = memberType === memberGoodsGroupCd
      const isValid = isMemberTheSame && memberStatus === 'NORMAL'
      const isFrozen = isMemberTheSame && memberStatus === 'FROZEN'
      const isExpired = isMemberTheSame && memberStatus === 'EXPIRED'
      return {
        isValid,
        isFrozen,
        isExpired
      }
    }
  },

  filters: {
    currency (num) {
      return formatMoney(num)
    },
    bankCardNo (no, visibleDigits = 4) {
      if (!no || no.length <= 4) {
        return no
      }
      const maskedPart = '*'.repeat(no.length - visibleDigits)
      const formattedMaskedPart = maskedPart.replace(/(.{4})/g, '$1 ') // 每隔 4 位加一个空格
      const formattedVisiblePart = no.slice(-visibleDigits).replace(/(.{4})/g, '$1 ') // 格式化最后 4 位
      return `${formattedMaskedPart}${formattedVisiblePart}`.trim() // 拼接并去掉多余空格
    },
    toFixed (value) {
      return Math.floor(value / 10000)
    },
    amount (num) {
      return formatAmount(num)
    },

    mobile (mobile) {
      return stringMosaic(mobile, 3, 4)
    },

    date (dateString, fmt) {
      return formatDate(dateString, fmt)
    },

    platform (value) {
      const mapping = {
        YZD: '聚美颜值贷',
        LFQ: '领分期'
      }
      return mapping[value]
    }
  }
}

export default {
  install (Vue) {
    Vue.prototype.$storage = {
      set: setKey,
      get: getKey,
      remove: removeKey
    }
    Vue.mixin(commonMethods)
  }
}